<template>
  <DialogWrapper v-if="open">
    <div class="solid" @wheel.prevent @scroll.prevent @touchmove.prevent />
    <DialogMotion
      class="dialog-motion"
      :motion-key="dialogKey"
      :position="position"
      @leave="leave"
    >
      <render class="dialog" />
    </DialogMotion>
  </DialogWrapper>
</template>
<script lang="ts" setup>
import { isTouchDevice } from '~/lib/utils/device';
import DialogWrapper from '~/components/dialog/wrapper/DialogWrapper.vue';
const dialog = useDialogStore();
const open = ref(false);
const position = ref<'center' | 'top-right'>('center');

const render = () => {
  if (!dialog.view) return h('div', { key: 'empty' });
  position.value = dialog.props.position ? dialog.props.position : 'center';
  return h(dialog.view, { ...dialog.props, key: 'dialog' });
};

const dialogKey = computed(() => {
  const k = dialog.view ? ((dialog.view as any).__name as string) : 'empty';
  return k;
});

const disableScroll = () => {
  if (isTouchDevice()) return;
  const scrollTop = document.documentElement.scrollTop;
  window.onscroll = function () {
    window.scrollTo(0, scrollTop);
  };
};

const enableScroll = () => {
  window.onscroll = function () {};
};

const leave = () => {
  enableScroll();
  open.value = false;
  document.documentElement.classList.remove('dialog-opened');
  dialog.closeComplete();
};

watchEffect(() => {
  if (dialog.view) {
    disableScroll();
    open.value = true;
    document.documentElement.classList.add('dialog-opened');
  }
});
</script>
<style lang="scss" scoped>
.solid {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.dialog {
  pointer-events: auto;
}
</style>
<style lang="scss">
html {
  &.dialog-opened {
    overscroll-behavior-y: none;
    body {
      overscroll-behavior-y: none;
    }
  }
}
</style>
